export class Drawing {

    timestamp: string;
    bingoGameId: number;
    numbers: number[];

    constructor(timestamp: string, numbers: number[], bingoGameId: number) {
        this.timestamp = timestamp;
        this.numbers = numbers;
        this.bingoGameId = bingoGameId;
    }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/domain/drawing.ts